import { fetch } from "src/services/apollo-fetch";
import { Query, Mutation } from "../_api";

export default {
    async moveUnit({ commit }, data) {
        const response = await fetch.mutate({
            mutation: Mutation.movePreOrderUnit,
            variables: { input: data },
        });
        commit("updatePreOrderUnitOrder", response.data.movePreOrderUnit);
    },
    async fetchPreOrder({ commit }, id) {
        const response = await fetch.query({
            query: Query.preOrder,
            variables: { id },
        });
        commit("setSelectedPreOrder", response.data.preOrder);
    },
};
